import * as z from 'zod';

export const ListCategoriesRequest = z.object({
  options: z
    .object({
      categoryIds: z.array(z.string()).optional(),
      includeDeleted: z
        .boolean()
        .describe(
          'Whether to include deleted categories in the response.\n\nDefault: `false`'
        )
        .optional()
        .nullable(),
    })
    .describe('Options to use when listing categories.')
    .optional(),
});
export const ListCategoriesResponse = z.object({
  categories: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Category ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        name: z
          .string()
          .describe('Category name.')
          .max(500)
          .optional()
          .nullable(),
        status: z
          .enum(['CREATED', 'DELETED'])
          .describe('Category status.\n\nDefault: `CREATED`')
          .optional(),
        sortOrder: z
          .number()
          .int()
          .describe(
            'Sort order of the category in the live site and dashboard.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
});
export const CreateCategoryRequest = z.object({
  category: z
    .object({
      _id: z
        .string()
        .describe('Category ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z.string().describe('Category name.').max(500),
      status: z.enum(['CREATED', 'DELETED']).optional(),
      sortOrder: z
        .number()
        .int()
        .describe('Sort order of the category in the live site and dashboard.')
        .optional()
        .nullable(),
    })
    .describe('Category to create.'),
});
export const CreateCategoryResponse = z.object({
  _id: z
    .string()
    .describe('Category ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z.string().describe('Category name.').max(500).optional().nullable(),
  status: z
    .enum(['CREATED', 'DELETED'])
    .describe('Category status.\n\nDefault: `CREATED`')
    .optional(),
  sortOrder: z
    .number()
    .int()
    .describe('Sort order of the category in the live site and dashboard.')
    .optional()
    .nullable(),
});
export const UpdateCategoryRequest = z.object({
  _id: z
    .string()
    .describe('Category ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  category: z
    .object({
      _id: z
        .string()
        .describe('Category ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z.string().describe('Category name.').max(500),
      status: z.enum(['CREATED', 'DELETED']).optional(),
      sortOrder: z
        .number()
        .int()
        .describe('Sort order of the category in the live site and dashboard.')
        .optional()
        .nullable(),
    })
    .describe('Category to update.'),
});
export const UpdateCategoryResponse = z.object({
  category: z
    .object({
      _id: z
        .string()
        .describe('Category ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z
        .string()
        .describe('Category name.')
        .max(500)
        .optional()
        .nullable(),
      status: z
        .enum(['CREATED', 'DELETED'])
        .describe('Category status.\n\nDefault: `CREATED`')
        .optional(),
      sortOrder: z
        .number()
        .int()
        .describe('Sort order of the category in the live site and dashboard.')
        .optional()
        .nullable(),
    })
    .describe('Updated category.')
    .optional(),
});
export const DeleteCategoryRequest = z.object({
  _id: z
    .string()
    .describe('ID of the category to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      deleteServices: z
        .boolean()
        .describe(
          'Whether to delete all the services associated with the category.\n\nDefault: `false`'
        )
        .optional()
        .nullable(),
    })
    .optional(),
});
export const DeleteCategoryResponse = z.object({
  _id: z
    .string()
    .describe('ID of the deleted category.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
});
